import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=6030bd19&scoped=true&"
import script from "./CustomDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CustomDashboard.vue?vue&type=style&index=0&id=6030bd19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030bd19",
  null
  
)

export default component.exports